import React from "react";
import {
  FaWhatsapp,
  FaFacebook,
  FaTiktok,
} from "react-icons/fa";

const socialMediaLinks = [
  {
    name: "WhatsApp",
    icon: <FaWhatsapp />,
    url: "https://wa.me/2347064058684?text=Hello%20CHAREX%2C%20I%20would%20like%20to%20make%20an%20inquiry.",
  },
  {
    name: "Facebook",
    icon: <FaFacebook />,
    url: "https://www.facebook.com/share/19NPYXYt7e/?mibextid=wwXIfr",
  },
  {
    name: "TikTok",
    icon: <FaTiktok />,
    url: "https://www.tiktok.com/@preorderwithcharex?_r=1&_t=ZN-98K5IDiaC7q",
  },
];

const quickLinks = [
  { link: "Home", path: "home" },
  { link: "About", path: "about" },
  { link: "Products", path: "products" },
  { link: "FAQ", path: "faq" },
  { link: "Contact", path: "contact" },
];

const handleScrollAdjust = (event, path) => {
  event.preventDefault();

  const target = document.getElementById(path);

  if (!target) {
    console.warn(`Navigation target with id "${path}" was not found.`);
    return;
  }

  const header = document.querySelector("header");

  const offset = header?.offsetHeight || 100;

  const top =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    offset -
    12;

  window.scrollTo({
    top: Math.max(top, 0),
    behavior: "smooth",
  });

  try {
    window.history.replaceState(null, "", `#${path}`);
  } catch {
    // Ignore URL update errors.
  }
};

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#4c1d95] via-[#6d28d9] to-[#45a864] text-white py-10 px-4">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-10">
          {/* Brand */}
          <div className="text-center lg:text-left max-w-md">
            <h2 className="text-3xl font-extrabold tracking-wide">
              CHAREX
            </h2>

            <p className="text-green-200 mt-2 font-medium">
              Shop Smart. Save More. Smile More.
            </p>

            <p className="text-sm text-purple-100 mt-4 leading-7">
              CHAREX is your trusted online shopping destination for quality,
              affordable and authentic products sourced from trusted suppliers
              and delivered right to your doorstep.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h2 className="text-xl font-bold mb-4">
              Quick Links
            </h2>

            <ul className="flex flex-wrap justify-center gap-6">
              {quickLinks.map(({ link, path }) => (
                <li key={path}>
                  <a
                    href={`#${path}`}
                    onClick={(event) =>
                      handleScrollAdjust(event, path)
                    }
                    className="relative inline-block pb-1 text-purple-100 hover:text-white cursor-pointer transition-colors duration-300 after:absolute after:left-0 after:-bottom-0.5 after:h-[2px] after:w-0 after:bg-white after:transition-all after:duration-300 hover:after:w-full"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div className="text-center lg:text-right">
            <h2 className="text-xl font-bold mb-4">
              Follow Us
            </h2>

            <div className="flex justify-center lg:justify-end gap-5 text-2xl">
              {socialMediaLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  title={social.name}
                  className="hover:text-green-300 transition duration-300 hover:scale-110"
                >
                  {social.icon}
                </a>
              ))}
            </div>

            <div className="mt-5 text-sm text-purple-100 space-y-2">
              <p>
                <a
                  href="tel:+2347064058684"
                  className="hover:text-green-300 hover:underline transition-colors duration-300"
                >
                  📞 +234 706 405 8684
                </a>
              </p>

              <p>
                <a
                  href="mailto:PreorderwithCharex@gmail.com"
                  className="break-all hover:text-green-300 hover:underline transition-colors duration-300"
                >
                  📧 PreorderwithCharex@gmail.com
                </a>
              </p>

              <p>
                📍 No. 44B Lumac Street, Satellite Town, Lagos, Nigeria
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 border-t border-purple-300/30 pt-6 text-center">
          <p className="text-sm text-purple-100">
            © {new Date().getFullYear()}{" "}
            <strong>CHAREX</strong>. All Rights Reserved.
          </p>

          <p className="text-xs italic text-green-200 mt-2">
            Shop Smart. Save More. Smile More.
          </p>

          <p className="text-xs text-purple-200 mt-2">
            Developed by Jay Global Digital • +234 803 061 1606
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;